export default {
  currentStep: 1,
  maxStep: 7,
};
